import { createApi } from "@reduxjs/toolkit/query/react";

import { dynamicBaseQuery } from "@/api/DynamicBaseQuery";
import { APIEndpoints } from "@/constants/apiEndpoints";
import type {
  TGetQuickActivitiesRequest,
  TGetQuickActivitiesResponse,
} from "@/types/(company)/quickActivity.interface";

const { QuickActivity } = APIEndpoints.MySpace;

export const mySpaceQuickActivityApi = createApi({
  reducerPath: "mySpaceQuickActivityApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["MySpaceQuickActivities"],
  endpoints: (builder) => ({
    getMySpaceQuickActivities: builder.query<
      TGetQuickActivitiesResponse,
      TGetQuickActivitiesRequest
    >({
      query: (params) => ({
        url: QuickActivity.GetAll,
        method: "GET",
        params,
      }),
      providesTags: ["MySpaceQuickActivities"],
    }),
  }),
});

export const { useGetMySpaceQuickActivitiesQuery } = mySpaceQuickActivityApi;
